const budgetCategoryRequiredAccountsPatterns = ['Expenses/Recruiting'];

export const isBudgetCategoryRequired = (accountId: any) =>
  !!accountId && budgetCategoryRequiredAccountsPatterns.some(account => accountId?.startsWith(account));
